module.exports = __webpack_public_path__ + "img/logo-aula3.0d5bea14.png";